<div 
  *ngIf="isVisible" 
  class="fixed left-0 right-0 bottom-0 z-[100] bg-black/95 backdrop-blur-sm transition-opacity duration-300"
  [style.top.px]="topOffset"
  (click)="close()"
>
  <!-- Main Container -->
  <div 
    class="relative h-full w-full flex flex-col items-center justify-center p-4"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="absolute top-0 left-0 right-0 flex justify-between items-center p-4 z-[101]">
      <div class="flex items-center space-x-3">
        <div 
          *ngIf="images.length > 1"
          class="px-3 py-1.5 rounded-full bg-black/80 backdrop-blur-sm text-white text-sm font-medium"
        >
          {{ currentIndex + 1 }} / {{ images.length }}
        </div>
        <div class="px-3 py-1.5 rounded-full bg-black/80 backdrop-blur-sm text-white text-sm font-medium">
          {{ (scale * 100).toFixed(0) }}%
        </div>
      </div>
      <div class="flex items-center space-x-2">
        <ng-container *ngIf="!isIOS(); else iosDownload">
          <a
            [href]="getCurrentImage()"
            [attr.download]="getCurrentImageFilename()"
            class="p-3 rounded-full bg-black/80 backdrop-blur-sm text-white hover:bg-black/90 \
                   transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white/20 flex items-center space-x-2"
            (click)="$event.stopPropagation()"
            title="Download image"
          >
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 4v12" />
            </svg>
            <span class="ml-2 text-sm font-medium">Download Image</span>
          </a>
        </ng-container>
        <ng-template #iosDownload>
          <button
            class="p-3 rounded-full bg-black/80 backdrop-blur-sm text-white hover:bg-black/90 \
                   transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white/20 flex items-center space-x-2"
            (click)="openImageInNewTab(); $event.stopPropagation()"
            title="Open image in new tab"
          >
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 4v12" />
            </svg>
            <span class="ml-2 text-sm font-medium">Open Image</span>
          </button>
          <span class="text-xs text-white/70 ml-2">Tap and hold the image to save it to your device.</span>
        </ng-template>
        <button 
          class="p-3 rounded-full bg-black/80 backdrop-blur-sm text-white hover:bg-black/90 \
                 transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white/20"
          (click)="close()"
        >
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Mobile Gesture Hint -->
    <div class="sm:hidden absolute top-4 left-4 z-20">
      <div class="px-3 py-1.5 rounded-full bg-black/80 backdrop-blur-sm text-white text-sm">
        <!-- Tap outside to close -->
      </div>
    </div>

    <!-- Image Container with Navigation -->
    <div class="relative w-full h-full flex items-center justify-center">
      <!-- Left Controls -->
      <div class="absolute left-4 top-1/2 -translate-y-1/2 flex flex-col space-y-6 z-10">
        <button 
          *ngIf="currentIndex > 0"
          class="group relative flex items-center"
          (click)="previous()"
        >
          <div class="absolute right-full mr-2 px-2 py-1 rounded bg-black/60 backdrop-blur-sm text-white/90 
                      opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-sm whitespace-nowrap">
            Previous Image
          </div>
          <div class="p-3 rounded-full bg-black/60 backdrop-blur-sm text-white/90 
                      hover:bg-black/80 hover:text-white transition-all duration-200 
                      transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white/20">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
          </div>
        </button>

        <button 
          (click)="zoomOut()"
          class="group relative flex items-center"
        >
          <div class="absolute right-full mr-2 px-2 py-1 rounded bg-black/60 backdrop-blur-sm text-white/90 
                      opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-sm whitespace-nowrap">
            Zoom Out
          </div>
          <div class="p-3 rounded-full bg-black/60 backdrop-blur-sm text-white/90 
                      hover:bg-black/80 hover:text-white transition-all duration-200 
                      transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white/20">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
            </svg>
          </div>
        </button>
      </div>

      <!-- Image -->
      <div class="relative w-full h-full flex items-center justify-center overflow-hidden">
        <img 
          [src]="getCurrentImage()" 
          [style.transform]="'scale(' + scale + ')'"
          class="max-w-[90%] max-h-[80vh] object-contain transition-transform duration-300 ease-out"
          alt="Viewer image"
          (touchstart)="onTouchStart($event)"
          (touchmove)="onTouchMove($event)"
          (touchend)="onTouchEnd()"
        >
      </div>

      <!-- Right Controls -->
      <div class="absolute right-4 top-1/2 -translate-y-1/2 flex flex-col space-y-6 z-10">
        <button 
          *ngIf="currentIndex < images.length - 1"
          class="group relative flex items-center"
          (click)="next()"
        >
          <div class="absolute left-full ml-2 px-2 py-1 rounded bg-black/60 backdrop-blur-sm text-white/90 
                      opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-sm whitespace-nowrap">
            Next Image
          </div>
          <div class="p-3 rounded-full bg-black/60 backdrop-blur-sm text-white/90 
                      hover:bg-black/80 hover:text-white transition-all duration-200 
                      transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white/20">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </button>

        <button 
          (click)="zoomIn()"
          class="group relative flex items-center"
        >
          <div class="absolute left-full ml-2 px-2 py-1 rounded bg-black/60 backdrop-blur-sm text-white/90 
                      opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-sm whitespace-nowrap">
            Zoom In
          </div>
          <div class="p-3 rounded-full bg-black/60 backdrop-blur-sm text-white/90 
                      hover:bg-black/80 hover:text-white transition-all duration-200 
                      transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white/20">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
            </svg>
          </div>
        </button>
      </div>
    </div>

    <!-- Footer -->
    <div class="absolute bottom-0 left-0 right-0 p-6 flex flex-col items-center space-y-4">
      <!-- Desktop Shortcuts -->
      <div class="hidden sm:flex space-x-6">
        <div class="flex items-center space-x-2 text-white/70">
          <kbd class="px-2 py-1 text-xs font-semibold bg-black/40 rounded-md backdrop-blur-sm">←</kbd>
          <span class="text-sm">Previous</span>
        </div>
        <div class="flex items-center space-x-2 text-white/70">
          <kbd class="px-2 py-1 text-xs font-semibold bg-black/40 rounded-md backdrop-blur-sm">→</kbd>
          <span class="text-sm">Next</span>
        </div>
        <div class="flex items-center space-x-2 text-white/70">
          <kbd class="px-2 py-1 text-xs font-semibold bg-black/40 rounded-md backdrop-blur-sm">ESC</kbd>
          <span class="text-sm">Close</span>
        </div>
        <div class="flex items-center space-x-2 text-white/70">
          <kbd class="px-2 py-1 text-xs font-semibold bg-black/40 rounded-md backdrop-blur-sm">+/-</kbd>
          <span class="text-sm">Zoom</span>
        </div>
      </div>

      <!-- Mobile Gestures -->
      <div class="sm:hidden flex space-x-6 text-white/70">
        <div class="flex items-center space-x-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
          </svg>
          <span class="text-sm">Swipe to navigate</span>
        </div>
        <div class="flex items-center space-x-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4 0l-5-5" />
          </svg>
          <span class="text-sm">Pinch to zoom</span>
        </div>
      </div>

      <!-- Caption -->
      <div 
        *ngIf="getCurrentCaption()"
        class="text-white/90 text-sm font-medium px-4 py-2 rounded-full bg-black/60 backdrop-blur-sm max-w-lg text-center"
      >
        {{ getCurrentCaption() }}
      </div>
    </div>
  </div>
</div>
